<template>
<div>
  <div class="frameBg" v-show="showModal2"></div>
    <div class="frameInput" style="margin-top:-356px;" v-show="claimBox">
        <div class="frameHead indexHead clear">
          <p class="l">Claim clause</p><p @click="getClose" class="r" style="font-size:26px;">×</p>
        </div>
        <div class="content">
           <label>
             <h3>I. insurance instructions</h3>
             <p>When the value of the goods is 600USD, it is recommended that you apply for insurance. The calculation method: insurance premium = the insured amount *1.8‰.Deductible: the absolute deductible for each accident shall be USD 200 or 5% of the insured amount, whichever is higher.Uninsurable areas: Cuba, Korea, or other areas of departure, passage, or arrival from which war or armed conflict has been declared.</p>
           </label>
           <label>
             <h3>II. Settlement rules:</h3>
             <p>The shipper shall provide relevant certificates of loss, damage or error, such as the certificate of loss (damage), the opening inspection certificate of the recipient and photos of the goods on site.If the info. is complete and correct, the verification will be carried out. The maximum time is no more than 90 days to reply the claim result.Claims filed beyond the opening time of the supplier channel will not be accepted.No insurance for loss or damage</p>
            <p>1. The compensation shall be declared according to the value of the invoice accompanying the goods.</p>
            <p>2. Compensation shall be made according to the details of supplier channels selected by the goods.</p>
            <p>3. The maximum compensation is USD100/ ticket (for example, 10 pieces of single ticket, 8 pieces of which have been received, shall be deemed as lost 2 pieces, and the compensation shall be USD20 according to the standard), and there is no compensation for freight.In the event of a claim, the claim will be made for the lower of the three.</p>
           </label>
           <label>
             <h3>III. Scope of exemption from liability</h3>
             <p>No compensation shall be made for any loss caused by:</p>
            <p>1. Any loss of weapons and ammunition, cash, cheques, bills, documents, securities, letters of credit, passports, satellites, and articles of art, gold and silver, jewelry, jewelry, diamonds, jade, marble, cultural relics and antiques.</p>
            <p>2. Any loss of animals and plants, Marine products, fresh and fresh goods, blood products, perishable goods and goods that need to be transported under refrigeration.</p>
            <p>3. If the lead seal or outer package is in good condition, or the consignee has signed and received the goods in good condition, the goods are short or short in quantity or other losses, the goods are unattended (including the goods stored in the parking lot), the goods are stolen or lost.</p>
            <p>4. Any loss arising from the repair, return to the factory or goods in use, as well as used goods and equipment.</p>
            <p>5. Any loss caused by the nature of the goods.</p>
            <p>6. Depreciation or impairment of market prices, whether or not caused by an insured event.</p>
            <p>7. Risk of confiscation and rejection, risk of indirect and loss of profits, and any loss caused by risk of liability.</p>
            <p>8. Factors not under the control of the carrier (such as the seizure of goods by the customs, the recipient's failure to cooperate with customs clearance, and the goods' failure to be delivered due to the recipient's reasons).</p>
            <p>9. Loss of goods due to improper packing is not covered by the insurance.</p>
            <p>10. The packages of fake goods, counterfeit goods, prohibited goods, restricted goods and other goods that violate the terms of shipment are lost due to the random inspection by the customs.</p>
           </label>
           <label>
             <h3>IV. No coverage</h3>
             <p>Freightshop shall not be liable for any loss or damage beyond the control of the supplier, including but not limited to:</p>
            <p>1. Natural disasters, such as earthquake, tornado, storm, flood, fog;War, air disaster or embargo force majeure, etc.</p>
            <p>2. Inherent defects or characteristics of the goods (whether known by Freightshop or not).</p>
            <p>Riots or civil commotion.</p>
            <p>3. ACTS or omissions of persons who are not employees of parkway or who have no contractual relationship with parkway, such as senders, consignees, third parties, customs or other government departments.</p>
            <p>4. Labour incidents, electromagnetic damage or deletion of electronic audio-visual images, data or records.</p>
            <p>5. The sender shall accept all routes and diversions arranged by the supplier, including possible transit stations, and shall not make any commitment on the limitation of transportation caused thereby.</p>
            <p>6. Cash, inflammable, explosive and fragile articles, articles involving infringement of copyright and intellectual property rights, illegal articles, as well as prohibited articles stipulated by airlines and laws, or clearly stated by supplier channels, will not be transported.The sender shall not be liable for any loss caused by its violation of the above provisions on prohibiting shipment, and reserves the right to pursue legal liabilities against the sender.</p>           
           </label>
        </div>
        <div class="framePwBtn">
              <a style="margin-left:40%;" class="sureA l" @click="getClose">Got it</a>
          </div>  
      </div>
</div>
     
</template>
<script>
  export default {
    props: {
      titNames:'',
      titUrls:''
    },
    data () {
      return {
        showModal2:false,
        claimBox:false,
      }
    },
    mounted:function(){
    },

    methods:{
      getClose(){ //关闭弹框
        this.showModal2=false
        this.claimBox=false
      },
      //打开弹框
      clkOpenBox(){
        this.showModal2=true
        this.claimBox=true
      },


    }

  }
</script>
<style lang="css" scoped>
  @import "../../../assets/css/frame.css";
  .frameInput .content label{margin:0 10px}
  .frameInput .content label h3{margin-bottom:5px;}
  .frameInput .content label p{color:#666;font-size:12px;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/claimClause.vue